import { Link, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Home, Info, Globe, User, Settings } from 'lucide-react';
import { ThemeToggle } from '@/components/theme/ThemeToggle';

const Header = () => {
  const location = useLocation();
  
  const isActive = (path: string) => {
    return location.pathname === path;
  };
  
  return (
    <header className="border-b border-border">
      <div className="container flex items-center justify-between h-16 px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2 font-semibold">
          <span className="text-xl font-bold">Agents of Learning</span>
        </Link>
        
        <nav className="hidden md:flex items-center gap-5">
          <Link to="/">
            <Button variant={isActive('/') ? 'default' : 'ghost'}>
              <Home className="w-4 h-4 mr-2" />
              Home
            </Button>
          </Link>
          <Link to="/explore">
            <Button variant={isActive('/explore') ? 'default' : 'ghost'}>
              <Globe className="w-4 h-4 mr-2" />
              Explore
            </Button>
          </Link>
          <Link to="/about">
            <Button variant={isActive('/about') ? 'default' : 'ghost'}>
              <Info className="w-4 h-4 mr-2" />
              About
            </Button>
          </Link>
          <Link to="/dashboard">
            <Button variant={isActive('/dashboard') ? 'default' : 'ghost'}>
              <User className="w-4 h-4 mr-2" />
              Dashboard
            </Button>
          </Link>
          <Link to="/admin">
            <Button variant={isActive('/admin') ? 'default' : 'ghost'}>
              <Settings className="w-4 h-4 mr-2" />
              Admin
            </Button>
          </Link>
          <ThemeToggle />
        </nav>
        
        <div className="flex md:hidden">
          {/* Mobile menu button would go here */}
          <ThemeToggle />
        </div>
      </div>
    </header>
  );
};

export default Header;
